// Pflichtfeld-Prüfung der Firmen-Vollanlage (NewCompanyContactForm) — als pure
// Funktion herausgelöst, damit die Regel testbar ist und an EINER Stelle lebt.
//
// **Pflicht sind nur noch Firmenname und Rechtsform** (PO-Notiz 02.08.). E-Mail
// und Rufnummer waren es vorher auch — das hielt die Anlage auf, wo es noch gar
// keine Kontaktdaten gibt (Messeliste, Empfehlung, Registerauszug). Beides
// bleibt erfassbar, nur eben freiwillig. Branche war schon vorher nicht Pflicht.
//
// Beim Produktpartner (Versicherungsgesellschaft) bleibt es beim Namen allein:
// Rechtsform ist in den GDV-Stammdaten regelmäßig unvollständig.

export type CompanyRequiredFields = {
  name?: string;
  gesellschaftsform?: string;
  /** Nur noch für Aufrufer-Kompatibilität — zählt nicht mehr als Pflicht. */
  email?: string;
  phone?: string;
  mobile?: string;
  /**
   * Produktpartner (Versicherungsgesellschaft) statt Kunde/Interessent. Dann
   * gilt nur der Name als Pflicht: die Rechtsform ist in den GDV-Stammdaten
   * regelmäßig unvollständig, und ein Produktpartner lässt sich nicht wie ein
   * Kundenunternehmen nacherfassen.
   */
  isProduktpartner?: boolean;
  /** Kontaktstatus „Interessent" — für die Pflichtfelder ohne Bedeutung. */
  isInteressent?: boolean;
};

const filled = (v?: string): boolean => (v ?? "").trim() !== "";

/**
 * Die Pflichtfeld-Checks der Firmen-Anlage in fester Reihenfolge (für den
 * Fortschrittszähler `RequiredFieldsProgress`).
 */
export function companyRequiredChecks(f: CompanyRequiredFields): boolean[] {
  if (f.isProduktpartner) return [filled(f.name)];
  return [filled(f.name), filled(f.gesellschaftsform)];
}
